import { z } from 'zod';
import { VollWalletPaymentMethodSchema } from './voll_wallet_list.js';

/** Como o saldo da carteira é liberado (`releasePeriodicity` do wallets-api, o `WalletRateType`
 *  do app legado). `BATCH` é a carga avulsa feita pelo gestor. */
export const VollWalletReleaseSchema = z.enum([
  'DAILY',
  'WEEKLY',
  'MONTHLY',
  'CUMULATIVE',
  'FLEXIBLE',
  'BATCH',
]);
export type VollWalletRelease = z.infer<typeof VollWalletReleaseSchema>;

/**
 * `GET /voll-wallet/rules?walletId=` — as regras de uma carteira, como a tela "Regras da
 * carteira" do app legado: as categorias permitidas, os meios de pagamento, se exige nota
 * fiscal e aceita a autodeclaração, e como o saldo é liberado. Fica fora da lista para a lista
 * não mudar de contrato a cada regra nova.
 */
export const VollWalletRulesSchema = z
  .object({
    id: z.string().min(1),
    name: z.string(),
    categories: z.array(z.string().min(1)),
    paymentMethods: z.array(VollWalletPaymentMethodSchema),
    invoiceRequired: z.boolean(),
    allowSelfDeclaration: z.boolean(),
    /** Ausente = a carteira não diz (ou o legado mostraria nada: `NONE`). */
    release: VollWalletReleaseSchema.optional(),
    /** ISO 4217; ausente = real. */
    currency: z.string().length(3).optional(),
    /** Último dia em que o saldo vale; ausente = sem validade. */
    validUntil: z.iso.date().optional(),
  })
  .strict();
export type VollWalletRules = z.infer<typeof VollWalletRulesSchema>;
